import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { Communities } from './pages/Communities';
import { Collective } from './pages/Collective';
import { Buyers } from './pages/Buyers';
import { Sellers } from './pages/Sellers';
import { Contact } from './pages/Contact';
import { DealFlowLayout } from './dealflow/DealFlowLayout';
import { DealFlowHome } from './dealflow/DealFlowHome';
// Scroll to top on route change
const ScrollToTop = () => {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <Routes data-id="element-2">
        {/* DealFlow Routes */}
        <Route path="/dealflow" element={<DealFlowLayout data-id="element-4">
              <DealFlowHome data-id="element-5" />
            </DealFlowLayout>} data-id="element-3" />

        {/* CaboCollection Routes */}
        <Route path="/*" element={<Layout data-id="element-7">
              <Routes data-id="element-8">
                <Route path="/" element={<Home data-id="element-10" />} data-id="element-9" />
                <Route path="/communities" element={<Communities data-id="element-12" />} data-id="element-11" />
                <Route path="/collective" element={<Collective data-id="element-14" />} data-id="element-13" />
                <Route path="/buyers" element={<Buyers data-id="element-16" />} data-id="element-15" />
                <Route path="/sellers" element={<Sellers data-id="element-18" />} data-id="element-17" />
                <Route path="/contact" element={<Contact data-id="element-20" />} data-id="element-19" />
              </Routes>
            </Layout>} data-id="element-6" />
      </Routes>
    </BrowserRouter>;
}